import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import CountryCodeSelect from './CountryCodeSelect';
import { sanitizePhoneNumber } from '../src/utils/phoneUtils';

interface PhoneInputProps {
  phone: string;
  countryCode: string;
  onPhoneChange: (phone: string) => void;
  onCountryCodeChange: (code: string) => void;
  hasError?: boolean;
  placeholder?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  phone,
  countryCode,
  onPhoneChange,
  onCountryCodeChange,
  hasError,
  placeholder,
}) => {
  const { t } = useTranslation();

  const handlePhoneChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    // 只保留数字
    const sanitized = sanitizePhoneNumber(e.target.value);
    onPhoneChange(sanitized);
  }, [onPhoneChange]);

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <CountryCodeSelect
        value={countryCode}
        onChange={onCountryCodeChange}
        hasError={hasError}
        className="w-full sm:w-auto"
      />
      <input
        type="tel"
        value={phone}
        onChange={handlePhoneChange}
        placeholder={placeholder || t('applicationForm.phonePlaceholder')}
        className={`w-full sm:flex-1 bg-slate-50 border ${
          hasError ? 'border-red-400' : 'border-slate-100'
        } rounded-xl px-5 py-3.5 text-slate-900 font-medium focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all`}
      />
    </div>
  );
};

export default React.memo(PhoneInput);
